import React from 'react';
import { Instagram, Facebook, Youtube } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { CONTACT } from '../mock';

export default function SideSocial() {
  const location = useLocation();
  const onDark = location.pathname === '/';
  return (
    <div className="hidden md:flex fixed left-4 top-1/2 -translate-y-1/2 z-40 flex-col gap-3">
      <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className={`w-11 h-11 rounded-full backdrop-blur border transition-all flex items-center justify-center ${onDark ? 'bg-black/40 border-white/30 text-white hover:bg-[#ED2E2E] hover:border-[#ED2E2E]' : 'bg-white border-gray-200 text-[#0F1C2E] hover:bg-[#ED2E2E] hover:text-white hover:border-[#ED2E2E]'}`}>
        <Facebook size={17} />
      </a>
      <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className={`w-11 h-11 rounded-full backdrop-blur border transition-all flex items-center justify-center ${onDark ? 'bg-black/40 border-white/30 text-white hover:bg-[#ED2E2E] hover:border-[#ED2E2E]' : 'bg-white border-gray-200 text-[#0F1C2E] hover:bg-[#ED2E2E] hover:text-white hover:border-[#ED2E2E]'}`}>
        <Instagram size={17} />
      </a>
      <a href={CONTACT.youtube} target="_blank" rel="noopener noreferrer" aria-label="Youtube" className={`w-11 h-11 rounded-full backdrop-blur border transition-all flex items-center justify-center ${onDark ? 'bg-black/40 border-white/30 text-white hover:bg-[#ED2E2E] hover:border-[#ED2E2E]' : 'bg-white border-gray-200 text-[#0F1C2E] hover:bg-[#ED2E2E] hover:text-white hover:border-[#ED2E2E]'}`}>
        <Youtube size={17} />
      </a>
    </div>
  );
}
